import css from './EmptyState.module.css';

export default function EmptyState({ message, cta, className }) {
  return (
    <div className={[css.emptyState, className||''].filter(Boolean).join(' ')}>
      <p className={css.message}>{message}</p>
      {cta && (
        <button className={css.cta} onClick={cta.onClick}>{cta.label}</button>
      )}
    </div>
  );
}
